module.exports = __webpack_public_path__ + "static/media/green_animal_amphibians_5.29bd47e2.webp";